module.exports = __webpack_public_path__ + "static/media/info-icon.85265d96.svg";